import type {ResponseUpdateAuditDataFieldsBody} from './ResponseUpdateAuditDataFieldsBody';

export type UpdateAuditDataCategories = {
  id: string;
  fields: Array<ResponseUpdateAuditDataFieldsBody>;
};
